const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '{clientId}';
const ISSUER = process.env.REACT_APP_ISSUER || 'https://{yourEntraDomain}/default';
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID, // References the .env variable
    authority: ISSUER,
    redirectUri: REDIRECT_URI,
  },
};
